import { Box } from '@mui/material';

const loadingAnimation = `
  @keyframes loadingDots {
    0%, 20% {
      transform: translateY(0);
      opacity: 1;
    }
    40% {
      transform: translateY(-10px);
      opacity: 0.7;
    }
    60% {
      transform: translateY(0);
      opacity: 1;
    }
    80%, 100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const LoadingDots = () => {
  return (
    <>
      <style>{loadingAnimation}</style>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            sx={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              backgroundColor: 'info.main',
              animation: `loadingDots 1.4s ease-in-out infinite`,
              animationDelay: `${index * 0.2}s`,
            }}
          />
        ))}
      </Box>
    </>
  );
};
